import type { ReactNode } from 'react'
import { Box } from '@n26/nxd'
import { Header } from '@/shared/components/Header'
import styles from './AppLayout.module.css'

type AppLayoutProps = {
  children: ReactNode
}

export const AppLayout = ({ children }: AppLayoutProps) => (
  <Box className={styles.page}>
    <Header />
    <Box
      as='main'
      paddingX='24'
      paddingTop={{ mobile: '24', desktop: '32' }}
      paddingBottom={{ mobile: '24', desktop: '32' }}
      className={styles.main}
    >
      <div className={styles.container}>{children}</div>
    </Box>
  </Box>
)
